import { get, post } from '@classic/Foundation/Services/ApiService'
import type { OptInPreferences } from '../types'

const enum LocalConstants {
  apiEndpoint = '/api/v2/communication-preferences',
}

export const getPreferencesFromApi = () =>
  get<CommunicationPreferences>({ url: LocalConstants.apiEndpoint })

export const postPreferencesToApi = (newPrefs: OptInPreferences) =>
  post<OptInPreferences>({ url: LocalConstants.apiEndpoint, body: newPrefs })

// =====
// Types
// =====

export interface CommunicationPreferences {
  ContactInfo: {
    Email: string
    MailingAddress: string
    Mobile: string
    Phone: string
  }
  OptInPreferences: OptInPreferences
}
